<template>
  <div class="flex flex-col items-center justify-center w-full h-[100vh] bg-white-primary">
    <img
      :src="permissionDeny"
      class="h-[160px] w-[160px]"
    />
    <t-space
      direction="vertical"
      class="flex justify-center"
    >
      <p v-if="loading">
        <loading-icon class="text-brand" />
        Checking permissions...
      </p>
      <template v-else>
        <p class="text-black-primary opacity-60">No access permission</p>
        <t-button v-if="gameStore.gameCode">Access Request</t-button>
        <t-button v-else>Select Game</t-button>
      </template>
    </t-space>
  </div>
</template>

<script setup lang="ts">
import permissionDeny from '@/assets/img/permissionDeny.png';
import { LoadingIcon } from 'tdesign-icons-vue-next';
import { useGlobalGameStore } from '@/store/global/game.store';
defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
});

const gameStore = useGlobalGameStore();
</script>
